import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'

import SurveyView from '@/views/survey-views/SurveyView.vue'

import DownloadResultsView from '@/views/DownloadResultsView.vue'
import SavedSurvey from '@/views/survey-views/SavedSurvey.vue'
import SurveysView from '@/views/SurveysView.vue'
import UsersView from '@/views/UsersView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/saved-survey',
    name: 'saved-survey',
    component: SavedSurvey
  },
  {
    path: '/:id/survey',
    name: 'Survey',
    component: SurveyView
  },
  {
    path: '/download-results',
    name: 'download-results',
    component: DownloadResultsView
  },
  {
    path: '/surveys',
    name: 'surveys',
    component: SurveysView
  },
  {
    path: '/users',
    name: 'users',
    component: UsersView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
